import React, { useEffect, useState } from 'react';

// Rain effect component
export function Rain() {
  const [drops, setDrops] = useState([]);

  useEffect(() => {
    const newDrops = Array.from({ length: 100 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 2,
      duration: 0.5 + Math.random() * 0.5,
    }));
    setDrops(newDrops);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {drops.map((drop) => (
        <div
          key={drop.id}
          className="rain-drop"
          style={{
            left: `${drop.left}%`,
            animationDelay: `${drop.delay}s`,
            animationDuration: `${drop.duration}s`,
          }}
        />
      ))}
    </div>
  );
}

// Theme player component
export function ThemePlayer({ minimal = false }) {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className={`relative rounded-xl overflow-hidden ${minimal ? 'aspect-video' : ''}`}>
      <div className="relative aspect-video bg-black">
        <iframe
          className="absolute inset-0 w-full h-full"
          src="https://www.youtube-nocookie.com/embed/HWpa8BzECl0?rel=0&modestbranding=1"
          title="Some Songs Don't Take You to Neverland"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
        />
      </div>
      {!minimal && (
        <div className="mt-4">
          <p className="text-xs tracking-[0.2em] uppercase" style={{ color: 'var(--dp-everlit)' }}>
            Official soundtrack
          </p>
          <h3 className="mt-1 text-xl" style={{ fontFamily: 'var(--dp-font-display)' }}>
            Some Songs Don't Take You to Neverland
          </h3>
          <p className="mt-1 text-sm" style={{ color: 'var(--dp-fog)' }}>
            The Dark Pan · mGn1.6 Radio with Grad Fawkes
          </p>
        </div>
      )}
    </div>
  );
}

// Shell layout component with persistent navigation
export function Shell({ children }) {
  return (
    <div className="dark-pan-app min-h-screen" style={{ background: 'var(--dp-soot)' }}>
      {/* Persistent top nav bar */}
      <nav className="sticky top-0 z-50 flex items-center justify-between px-5 py-3 sm:px-8" style={{ background: 'rgba(11, 10, 9, 0.95)', borderBottom: '1px solid rgba(232, 223, 208, 0.1)', backdropFilter: 'blur(8px)' }}>
        <a href="/" className="text-sm font-medium flex items-center gap-2 hover:opacity-80 transition-opacity" style={{ color: 'var(--dp-everlit)' }} data-testid="nav-home">
          ← MGN1.6 Home
        </a>
        <a href="/dark-pan" className="text-sm font-medium hover:opacity-80 transition-opacity" style={{ color: 'var(--dp-bone)', fontFamily: 'var(--dp-font-display)' }} data-testid="nav-darkpan-home">
          The Dark Pan
        </a>
      </nav>
      {children}
    </div>
  );
}

// Button component
export function DPButton({ children, variant = 'primary', asChild, size = 'default', ...props }) {
  const baseClass = 'dp-btn';
  const variantClass = `dp-btn-${variant}`;
  const sizeClass = size === 'lg' ? 'px-6 py-3 text-base' : '';
  
  const className = `${baseClass} ${variantClass} ${sizeClass}`;

  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      className: `${className} ${children.props.className || ''}`,
      ...props,
    });
  }

  return (
    <button className={className} {...props}>
      {children}
    </button>
  );
}
